module.exports = __webpack_public_path__ + "static/media/poste_13.37981a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_13.jpg
// module id = 241
// module chunks = 0